import { render, staticRenderFns } from "./EventData.vue?vue&type=template&id=6daa93e6&"
import script from "./EventData.vue?vue&type=script&lang=js&"
export * from "./EventData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports